import { OriginalDocumentStatus } from '@/services/healthClaim/useOriginalDocumentList/types'
import styled from '@emotion/styled'

const handleDisplayOriginalDocumentStatusColor = ({
  status,
}: {
  status: OriginalDocumentStatus
}) => {
  const colorSet = {
    receivedOriginal: {
      background: '#009640',
    },
    notReceivedOriginal: {
      background: '#FFA100',
    },
  }
  return colorSet[status]?.background || '#000'
}

export const Dot = styled('div')<{ status: OriginalDocumentStatus }>`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: ${(props) => handleDisplayOriginalDocumentStatusColor({ status: props.status })};
`
